import styled from 'styled-components';

export const VerificationErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 474px;
    margin: auto;
    padding: 40px 0;

    .title {
        text-align: center;
        margin-bottom: 0;
    }

    .sub-title {
        text-align: center;
        margin-bottom: 0;
    }

    .no-attempts-icon {
        max-width: 128px;
        margin: 54px 0 44px 0;

        ${(props) => props.theme.breakpointTo.sm} {
            margin: 24px 0 12px 0;
            max-width: 103px;
        }
    }
`;
